module.exports = __webpack_public_path__ + "img/hero.050a1a63.png";